import React from 'react'
import { Link } from 'react-router-dom'

const SocialFacebook = () => {
  return (
    <a href="https://www.facebook.com/wisefamilychurchphopheticmission/?locale=en_GB">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="40" rx="20" fill="#D0D0C8"/>
          <path d="M28 20C28 15.6 24.4 12 20 12C15.6 12 12 15.6 12 20C12 24 14.9 27.3 18.7 27.9V22.3H16.7V20H18.7V18.2C18.7 16.2 19.9 15.1 21.7 15.1C22.6 15.1 23.5 15.3 23.5 15.3V17.3H22.5C21.5 17.3 21.2 17.9 21.2 18.5V20H23.4L23 22.3H21.1V28C25.1 27.4 28 24 28 20Z" fill="#181A1B"/>
      </svg>
    </a>
  )
}

export default SocialFacebook